import script from "./HeaderPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderPortal.vue?vue&type=script&setup=true&lang=js"

import "./HeaderPortal.vue?vue&type=style&index=0&id=42303f55&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42303f55"]])

export default __exports__